import React from "react";
import Modal from "react-bootstrap/Modal";
import PrintPaperShell from "../../pageInside/PrintPaperShell";
import GenericPrintTable from "../../pageInside/GenericPrintTable";
import { elakayAutoText } from "../../pageInside/dataElakay";

// Shared print modal for Provider My Products / Orders / Inventory (ticket parts 5-9): clicking
// the Printer icon opens THIS modal first -- never an immediate window.print() -- reusing the same
// Elakay print chrome (PrintPaperShell) and table renderer (GenericPrintTable) the "My Shop" print
// system already uses, just with each page's own columns/rows/permission-safe data.
export default function ProviderPrintModal({ show, onHide, infoSource, title, loading, error, columns, rows, documentTitle, itemNoun }) {
  return (
    <Modal show={show} onHide={onHide} centered size="xl" scrollable data-testid="provider-print-modal">
      <Modal.Header closeButton><Modal.Title>{title}</Modal.Title></Modal.Header>
      <Modal.Body>
        {loading && <p role="status">{elakayAutoText("h_pps_loading", "Loading…")}</p>}
        {!loading && error && <p role="alert">{error}</p>}
        {!loading && !error && (
          <PrintPaperShell infoSource={infoSource} documentTitle={documentTitle} items={rows} itemNoun={itemNoun}>
            {() => <GenericPrintTable columns={columns} rows={rows} />}
          </PrintPaperShell>
        )}
      </Modal.Body>
    </Modal>
  );
}
